export const SubscriptionStaticKeys = {
    MAIN_LOGO: 'main_logo',
    PRIMARY_LOGO:'primary_logo',
    SECONDARY_LOGO: 'secondary_logo',
    TERTIARY_LOGO: 'tertiary_logo',
    BENEFIT_SECTION_HEADING: 'benefit_section_heading',
    CART_SAVING_LINE: 'cart_saving_line',
    CART_ITEM_HEADING: 'cart_item_heading',
    CART_ITEM_NOT_ADDED_HEADING:'cart_item_not_added_heading',
    CART_ITEM_FOOTER: 'cart_item_footer',
    CART_ITEM_NOT_ADDED_FOOTER: 'cart_item_not_added_footer', 
    CART_HALF_CARD_LOGO_FOR_HALF_CARD: 'cart_half_card_logo_for_half_card',
    CART_HALF_CARD_REMOVE_SUBSCRIPTION_CTA_TEXT: 'cart_half_card_remove_subscription_cta_text',
    CART_HALF_CARD_KEEP_SUBSCRIPTION_CTA_TEXT: 'cart_half_card_keep_subscription_cta_text',
    CART_HALF_CARD_FOOTER_TEXT: 'cart_half_card_footer_text',
    CART_HALF_CARD_SAVINGS_LINE: 'cart_half_card_savings_line',
    CART_HALF_CARD_HEADING: 'cart_half_card_heading',
    CART_SUBSCRIBED_SAVING_TEXT: 'cart_subscribed_saving_text',
    ABOUT_MEMBERSHIP_HEADING: "about_membership_heading",
    ABOUT_MEMBERSHIP_DETAILS: "About_membership_details",
    ABOUT_MEMBERSHIP_DISCLAIMER_1: "about_membership_disclaimer_1",
    ABOUT_MEMBERSHIP_DISCLAIMER_2: "about_membership_disclaimer_2",
    DISCLAIMER_1: "disclaimer_1",
    DISCLAIMER_2: "disclaimer_2",
    VALID_UNTIL_ICON: "valid_until_icon",
    NO_OF_ORDERS_ICON: "no_of_orders_icon",
    PRICE_COMPONENT_HEADING: "price_component_heading",
    PRICING_AND_BENEFITS_SLASHED_PRICE_LINE: "pricing_and_benefits_slashed_price_line",
    PRICING_AND_BENEFITS_ACTUAL_PAYMENT_LINE: "pricing_and_benefits_actual_payment_line",
    SAVINGS_CALCULATOR_HEADING: "savings_calculator_heading",
    SAVING_LINE: "saving_line",
    SAVINGS_ICON: "savings_icon",
    CUSTOMER_SUPPORT_HEADING: "customer_support_heading",
    CUSTOMER_SUPPORT_ICON: "customer_support_icon",
    CUSTOMER_SUPPORT_CTA_TEXT: "customer_support_cta_text",
    CUSTOMER_SUPPORT_BY_LINE: "customer_support_by_line",
    RENEWAL_HEADING: "renewal_heading",
    RENEWAL_SLASHED_PRICE: "renewal_slashed_price",
    RENEWAL_ACTUAL_PAYMENT_LINE: "renewal_actual_payment_line",
    RENEWAL_SUBSCRIBE_FOR_CTA_TEXT: "renewal_subscribe_for_cta_text",
    BLACKLISTED_USER_HEADING: "blacklisted_user_heading",
    BLACKLISTED_USER_SUB_LINE: "blacklisted_user_sub_line",
    BLACKLISTED_USER_NOTIFY_ME_CTA_TEXT: "blacklisted_user_notify_me_cta_text",
    T_N_C_HEADING: "t_n_c_heading",
    PAGE_URL: "page_url",
    FAQ_HEADING : "faq_heading",
    ACTIONS_BUTTONS_SUBSCRIBE_FOR_CTA_TEXT : "action_buttons_subscribe_for_cta_text",
    VIEW_BAG_CTA_TEXT : "view_bag_cta_text",
    CART_HALF_CARD_FOOTER_TEXT:'cart_half_card_footer_text',
    CART_ORDER_SUMMERY_HEADING:'cart_order_summery_heading',
    AJIO_FIRST_MEMBERSHIP_DISCOUNT_TEXT: 'cart_order_summery_membership_text',
    CART_MEMBERSHIP_REVIEW_TEXT: 'cart_membreship_review_text',
    CART_BLACKLISTED_TOAST_MESSAGE: 'cart_blacklisted_toast_message',
    CART_ORDER_SUMMERY_TOTAL_SAVING_TEXT:'cart_order_summery_total_saving_text',
    PLP_NOTCH_PAYMENT_LINE:'plp_notch_payment_line',
    PDP_HALF_CARD_HEADING:'pdp_half_card_heading',
    PDP_HALF_CARD_FOOTER_TEXT:'pdp_half_card_footer_text',
    PDP_HALF_CARD_ADD_TO_BAG_CTA_TEXT:'pdp_half_card_add_to_bag_cta_text',
    ACCOUNT_PAGE_TITLE : 'account_page_title',
    ACCOUNT_PAGE_PAYMENT_LINE : 'account_page_payment_line',
    ACCOUNT_PAGE_CTA_TEXT : 'account_page_cta_text',
    ACCOUNT_PAGE_ICON_FOR_LINE_ITEM_AJIOGRAM : 'account_page_icon_for_line_item_ajiogram',
    ACCOUNT_PAGE_ICON_FOR_LINE_ITEM_RENEWAL : 'account_page_icon_for_line_item_renewal',
    CART_DESKTOP_SAVING_TEXT:'cart_desktop_saving_text',
    MEMBERSHIP_HEADING: "membership_heading",
    VALID_TILL_HEADING: "valid_till_heading",
    ORDER_LEFT_HEADING: "order_left_heading",
    PLATFORM_FEE_SAVING: "platform_fee_saving",
    DELIVERY_FEE_SAVING: "delivery_fee_saving",
    MEMBERSHIP_DISCOUNT_SAVING: "membership_discount_saving",
    SUPERCASH_EARNINGS: "supercash_earnings",
    PENDING_SUPERCASH_EARNINGS: "pending_supercash_earnings",
    TOTAL_SAVING_HEADING: "total_saving_heading",
    SHARE_SECTION_HEADING: "share_section_heading",
    SHARE_SECTION_BY_LINE: "share_section_by_line",
    SHARE_SECTION_SHARE_ICON: "share_section_share_icon",
    SHARE_SECTION_CTA_TEXT: "share_section_cta_text",
    SHARE_SECTION_CTA_URL: "share_section_cta_url",
    ADD_TO_CART_TOAST_MESSAGE: "add_to_cart_toast_meassage",
    ADD_TO_CART_LOADER_MESSAGE: "add_to_cart_loader_message",
    NOTIFY_TOAST_MESSAGE: "notify_toast_message",
    PAGE_HEADING_HEADING: "page_heading_heading",
    THANK_YOU_PAGE_SECTION_HEADER: "thank_you_page_section_header",
    THANK_YOU_POPUP_DESCRIPTION_ONE: "thank_you_popup_description_one",
    THANK_YOU_POPUP_DESCRIPTION_TWO: "thank_you_popup_description_two",
    THANK_YOU_POPUP_STAR_IMAGE: "thank_you_popup_star_image",
    THANK_YOU_POPUP_CONGRATULATIONS:'thank_you_popup_congratulations',
    MY_ACCOUNT_SUBSCRIRPTION_TEXT: "my_account_subscription_text",
    SPC_DISCLAIMER_TEXT: "spc_disclaimer_text",
    SPC_DISCLAIMER_TEXT_ONLY_SUBSCRIBED_ITEM: "spc_disclaimer_text_only_subscribed_item",
    HOME_PAGE_COMPONENT_CTA_TEXT : "home_page_component_cta_text",
    HOME_COACH_MARK_TITLE: "home_coach_mark_title",
    HOME_COACH_MARK_DESCRIPTION: "home_coach_mark_description",
    TOTAL_SAVING_HEADING: "total_saving_heading",
    ACTION_BUTTON_VIEW_BAG_CTA_TEXT : "action_buttons_view_bag_cta_text"
}


